import { render, staticRenderFns } from "./ClientCreditTransactionsTab.vue?vue&type=template&id=26a5a01e&scoped=true&"
import script from "./ClientCreditTransactionsTab.vue?vue&type=script&lang=js&"
export * from "./ClientCreditTransactionsTab.vue?vue&type=script&lang=js&"
import style0 from "./ClientCreditTransactionsTab.vue?vue&type=style&index=0&id=26a5a01e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a5a01e",
  null
  
)

export default component.exports